"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSection = void 0;
var tslib_1 = require("tslib");
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var react_1 = tslib_1.__importStar(require("react"));
var DashboardLayoutGridRow_1 = require("./DashboardLayoutGridRow");
var DashboardLayoutSectionHeaderRenderer_1 = require("./DashboardLayoutSectionHeaderRenderer");
var DashboardLayoutSectionRenderer_1 = require("./DashboardLayoutSectionRenderer");
var DashboardItemOverlayController_1 = require("../DashboardItemOverlay/DashboardItemOverlayController");
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var DashboardLayoutGridRowEdit_1 = require("./DashboardLayoutGridRowEdit");
var defaultSectionRenderer = function (props) { return (react_1.default.createElement(DashboardLayoutSectionRenderer_1.DashboardLayoutSectionRenderer, tslib_1.__assign({}, props))); };
var defaultHeaderRenderer = function (props) { return (react_1.default.createElement(DashboardLayoutSectionHeaderRenderer_1.DashboardLayoutSectionHeaderRenderer, tslib_1.__assign({}, props))); };
var defaultItemKeyGetter = function (_a) {
    var item = _a.item;
    return item.index().toString();
};
function DashboardLayoutSection(props) {
    var section = props.section, _a = props.sectionRenderer, sectionRenderer = _a === void 0 ? defaultSectionRenderer : _a, _b = props.sectionHeaderRenderer, sectionHeaderRenderer = _b === void 0 ? defaultHeaderRenderer : _b, _c = props.itemKeyGetter, itemKeyGetter = _c === void 0 ? defaultItemKeyGetter : _c, gridRowRenderer = props.gridRowRenderer, itemRenderer = props.itemRenderer, widgetRenderer = props.widgetRenderer, getLayoutDimensions = props.getLayoutDimensions, screen = props.screen, renderMode = props.renderMode;
    var renderProps = { section: section, screen: screen, renderMode: renderMode };
    var items = react_1.useMemo(function () {
        if (renderMode === "edit") {
            var itemsInRowsByIndex = section
                .items()
                .asGridRows(screen)
                .map(function (itemsInRow) {
                return [last_1.default(itemsInRow).index(), itemsInRow];
            });
            var itemsInRow = section.items().all();
            return (react_1.default.createElement(DashboardLayoutGridRowEdit_1.DashboardLayoutGridRowEdit, { screen: screen, itemsInRowsByIndex: itemsInRowsByIndex, section: section, items: itemsInRow, gridRowRenderer: gridRowRenderer, itemKeyGetter: itemKeyGetter, itemRenderer: itemRenderer, widgetRenderer: widgetRenderer, renderMode: renderMode, getLayoutDimensions: getLayoutDimensions }));
        }
        return flatMap_1.default(section.items().asGridRows(screen), function (itemsInRow, index) {
            return (react_1.default.createElement(DashboardLayoutGridRow_1.DashboardLayoutGridRow, { key: index.toString(), screen: screen, section: section, items: itemsInRow, gridRowRenderer: gridRowRenderer, itemKeyGetter: itemKeyGetter, itemRenderer: itemRenderer, widgetRenderer: widgetRenderer, renderMode: renderMode, getLayoutDimensions: getLayoutDimensions }));
        });
    }, [
        getLayoutDimensions,
        gridRowRenderer,
        itemKeyGetter,
        itemRenderer,
        renderMode,
        screen,
        section,
        widgetRenderer,
    ]);
    return sectionRenderer(tslib_1.__assign(tslib_1.__assign({}, renderProps), { DefaultSectionRenderer: DashboardLayoutSectionRenderer_1.DashboardLayoutSectionRenderer, children: (react_1.default.createElement(react_1.default.Fragment, null,
            sectionHeaderRenderer({
                section: section,
                screen: screen,
                DefaultSectionHeaderRenderer: DashboardLayoutSectionHeaderRenderer_1.DashboardLayoutSectionHeaderRenderer,
            }),
            items,
            renderMode === "edit" ? react_1.default.createElement(DashboardItemOverlayController_1.DashboardLayoutSectionOverlayController, { section: section }) : null)) }));
}
exports.DashboardLayoutSection = DashboardLayoutSection;
//# sourceMappingURL=DashboardLayoutSection.js.map